/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Pricing of the performer\'s work with transport.
 */
export interface TariffPrimaryDelivery { 
    /**
     * The cost of the performer\'s shift.
     */
    cost_per_shift: number;
    /**
     * The cost for driving in one meter.
     */
    cost_per_meter: number;
    /**
     * The maximum tariff duration in meters should be more than zero.
     */
    max_length: number;
    /**
     * Cost per one minute.
     */
    cost_per_minute: number;
    /**
     * The maximum tariff duration in meters should be more than zero.
     */
    max_time: number;
}

